const HttpRequest = require('./http_request');
const logger = require('../../utils/logger');

const getGraphQLUrl = () => Odigeo.Settings.property('appContext') + '/service/graphql';

const get = () => ({
    credentials: 'same-origin',
    method: 'GET',
});

const post = (requestParams, hasToStringify = true) => ({
    credentials: 'same-origin',
    method: 'POST',
    body: hasToStringify ? JSON.stringify(requestParams) : requestParams,
});

const put = (requestParams, hasToStringify = true) => ({
    credentials: 'same-origin',
    method: 'PUT',
    body: hasToStringify ? JSON.stringify(requestParams) : requestParams,
});

module.exports = {
    get(url) {
        return new HttpRequest(url, get());
    },
    post(url, requestParams = {}, hasToStringify) {
        return new HttpRequest(url, post(requestParams, hasToStringify));
    },
    put(url, requestParams = {}, hasToStringify) {
        return new HttpRequest(url, put(requestParams, hasToStringify));
    },
    query(query, variables = {}) {
        return new HttpRequest(
            getGraphQLUrl(),
            post({
                query,
                variables,
            })
        )
        .json()
        .catch((error) => {
            logger.error(error, `GraphQL query: "${query}" - variables: ${JSON.stringify(variables)}`);
            throw error;
        });
    },
};
